import axios from 'axios';

import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';

import { createReducer } from 'utils/redux';
import { ROOT_PATH, get } from 'utils/api';

import type { StateVersion } from 'types/State.type';

const RECEIVE_VERSION = 'version/RECEIVE_VERSION';
const NEW_VERSION_RELEASED = 'version/NEW_VERSION_RELEASED';

const initialState: StateVersion = {
  frontend: process.env.VERSION!, // passed by webpack
  backend: 'unknown',
  backendSearch: 'unknown',
  newVersionReleased: false
};

function receiveVersion(data) {
  return {
    type: RECEIVE_VERSION,
    payload: {
      data
    }
  };
}

function updateNewVersionReleased(flag) {
  return {
    type: NEW_VERSION_RELEASED,
    payload: {
      newVersionReleased: flag
    }
  };
}

export function checkForNewVersion() {
  return (dispatch, getState) => (
    axios.get(`/version.json?q=${Math.random()}`)
      .then((resp: { data: { version: string } }) => {
        const currentVersion = getState().version.frontend;
        const newestVersion = resp.data.version;
        const hasNewVersion = newestVersion !== currentVersion;
        if (hasNewVersion) {
          dispatch(updateNewVersionReleased(hasNewVersion));
        }
      })
  );
}

export function fetchBackendVersion() {
  const url = `${ROOT_PATH.API}/health`;

  return (dispatch) => get(url)
    .then((response) => dispatch(receiveVersion({ backend: response.data.appVersion })));
}

export function fetchBackendSearchVersion() {
  const url = `${ROOT_PATH.API}/health`;

  return (dispatch) => get(url)
    .then((response) => dispatch(receiveVersion({ backendSearch: response.data.appVersion })));
}

export function fetchVersions() {
  return (dispatch) => {
    dispatch(showLoading('fetchVersions()'));

    return Promise
      .all([
        dispatch(fetchBackendVersion()),
        dispatch(fetchBackendSearchVersion())
      ])
      .then(() => dispatch(hideLoading('fetchVersions()')))
      .catch(() => dispatch(hideLoading('fetchVersions()')));
  };
}

export default createReducer<StateVersion, any>('version', initialState, {
  [RECEIVE_VERSION]: (state, { data }) => ({
    ...state,
    ...data
  }),
  [NEW_VERSION_RELEASED]: (state, { newVersionReleased }) => ({
    ...state,
    newVersionReleased
  })
});
